import { connect, type ConnectedProps } from "react-redux";
import { type RootState } from "../../../../../Application/globaltypes/redux";
import { Dimmer, Loader } from "semantic-ui-react";
import PeopleWrapper from "../../../../PeopleAssignments/Overview/PeopleWrapper/PeopleWrapper";
import { RolePermissions } from "../../../../../../enums";
import Sections from "../../../../../../enums/sections";
import UsersOverview from "../../../../PeopleAssignments/Overview/UsersOverview/UsersOverview";
import GroupsOverview from "../../../../PeopleAssignments/Overview/GroupsOverview/GroupsOverview";
import { campaignsStateSelector } from "../../state/selectors";
import TemplateGroupsOverview from "features/Library/PeopleAssignments/Overview/TemplateGroupsOverview/TemplateGroupsOverview";

export type PeopleProps = PropsFromRedux;

export const People = (props: PeopleProps) => {
  const {
    areUsersLoading,
    areGroupsLoading,
    areTemplateGroupsLoading,
    usersToAssign,
    groupsToAssign,
    templateGroupsToAssign,
  } = props;

  return (
    <>
      <Dimmer active={areUsersLoading || areGroupsLoading || areTemplateGroupsLoading} inverted>
        <Loader />
      </Dimmer>
      <PeopleWrapper
        permission={RolePermissions.UsersView}
        renderUsersOverview={(customHeader, isReadOnly) => (
          <UsersOverview
            section={Sections.tdf}
            customHeaderContent={customHeader}
            isReadOnly={isReadOnly}
            assignedPeopleIds={usersToAssign}
          />
        )}
        renderGroupsOverview={(customHeader, isReadOnly) => (
          <GroupsOverview
            section={Sections.tdf}
            customHeaderContent={customHeader}
            isReadOnly={isReadOnly}
            assignedPeopleIds={groupsToAssign}
          />
        )}
        renderTemplateGroupsOverview={(customHeader, isReadOnly) => (
          <TemplateGroupsOverview
            section={Sections.tdf}
            customHeaderContent={customHeader}
            isReadOnly={isReadOnly}
            assignedPeopleIds={templateGroupsToAssign}
          />
        )}
      />
    </>
  );
};

/* istanbul ignore next */
const mapStateToProps = (state: RootState) => {
  const base = campaignsStateSelector(state).base;

  return {
    usersToAssign: base.sends.people.assignedUsers.userIds,
    groupsToAssign: base.sends.people.assignedGroups.groupIds,
    templateGroupsToAssign: state.library.groupTemplatesAssignment.templatesToBeAssigned.selected,
    areUsersLoading: state.library.userAssignment.usersToBeAssigned.isLoading,
    areGroupsLoading: state.library.groupAssignment.groupsToBeAssigned.isLoading,
    areTemplateGroupsLoading: state.library.groupTemplatesAssignment.templatesToBeAssigned.isLoading,
  };
};

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(People);
export default ConnectedComponent;
